import { useRecoilValue } from 'recoil';

import { useUserIsLoggedIn } from '@app/user';
import { useDeviceId } from '@app/experiments';

import { messageIsReadUpdatesState } from '../state';
import useInboxMessages from './useInboxMessages';

const useNewInboxMessages = () => {
  const loggedIn = useUserIsLoggedIn();
  const deviceId = useDeviceId();

  const { messages, loading } = useInboxMessages(deviceId, 35, loggedIn);
  const messageIsReadUpdates = useRecoilValue(messageIsReadUpdatesState);

  return (
    !loading &&
    messages.some(
      (message) =>
        !message.node.isRead && !messageIsReadUpdates.includes(message.node.id),
    )
  );
};

export default useNewInboxMessages;
